import { Card as CardComponent, CardProps } from '@/ui';
import { RTEContent, WidthOptions } from '@types';
import clsx from 'clsx';

import { PageRenderTransition } from '@/lib/server';

import { BlockBase, getBlockWidthClassNames, getMarginClassNames } from '../utils';
import { transformCardData } from './transform-card-data';

export type CardBlockProps = CardProps &
  BlockBase & {
    rte_description?: RTEContent;
    transition?: PageRenderTransition;
    blockWidth?: WidthOptions;

    // these should be destructured from the props so they're not passed to the dom
    /** @deprecated */
    internalLink?: boolean;
  };

export function Card({ params, margin, blockWidth, ...data }: CardBlockProps) {
  const transformedData = transformCardData({ params, ...data });

  return (
    <CardComponent
      className={clsx(getMarginClassNames(margin), getBlockWidthClassNames(blockWidth))}
      {...transformedData}
    />
  );
}
